/**
 * Grid filter and grouping shapes. Unlike the rest of this directory these are
 * NOT wire shapes — the data grid builds them and the fetch layer takes them
 * apart again — so they have nothing to derive from. See ./README.md.
 */
import { z } from 'zod';

/**
 * A numeric column's filter, grouped under the field it filters. The wire
 * counterpart is flat (`proposed_amount`, `proposed_amount_gt`,
 * `proposed_amount_gte`, … on `InvoicesListQueryParams`); `fetchInvoicesFilter`
 * spreads this object onto those params.
 */
export const numberFilterParamsSchema = z.object({
  eq: z.number().optional(),
  gt: z.number().optional(),
  gte: z.number().optional(),
  lt: z.number().optional(),
  lte: z.number().optional(),
});
export type NumberFilterParams = z.infer<typeof numberFilterParamsSchema>;

/** The columns a property-scoped grid can row-group by. */
export type GroupableFields = 'portfolio' | 'property' | 'propertyManager';
